import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@missionlabs/smartagent-chat-components-lib/dist/index.css'
import 'normalize.css';
import './index.scss';
import '@missionlabs/amazon-connect-chatjs';

// suppress console outputs on prod to hide any sensitive websocket logs, etc.
if (process.env.REACT_APP_ENV === 'prod') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render( 
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
